<template>
  <CalloutsWithIcon
    v-if="calloutWithIcon"
    v-bind="calloutWithIcon"
    :use-inner-background="false"
  />
</template>
<script setup lang="ts">
import CalloutsWithIcon from '~/components/Atoms/CalloutsWithIcon/CalloutsWithIcon.vue';
import type { PortableTextCalloutWithIcon } from '~/sanity/types';

defineProps<PortableTextCalloutWithIcon>();
</script>

<style lang="scss" scoped></style>
